import type { ConversationMessage } from '../../conversation/pickFinalReply';

import { decodeMessageContent } from './decodeMessageContent';

// Returns the message from a terminal `vega_error` envelope, if any — the
// agent's explicit failure signal, so a run can fail fast instead of polling
// to the timeout.
export function findConversationError(messages: ConversationMessage[]): string | undefined {
  for (const message of messages) {
    if (message.role !== 'assistant') {
      continue;
    }
    const payload = decodeMessageContent(message.content);
    if (payload?.type === 'vega_error' && typeof payload.message === 'string') {
      return payload.message;
    }
  }
  return undefined;
}
